import { Close } from "@mui/icons-material"
import { Modal } from "@mui/material"
import html2canvas from "html2canvas"
import { jsPDF } from "jspdf"
import { useEffect, useState } from "react"
import { useGetCitiesQuery } from "../../../settings/settingsApi"

function getCurrentDateTime() {
  const now = new Date()

  const day = String(now.getDate()).padStart(2, "0")
  const month = String(now.getMonth() + 1).padStart(2, "0") // Месяцы начинаются с 0
  const year = now.getFullYear()

  const hours = String(now.getHours()).padStart(2, "0")
  const minutes = String(now.getMinutes()).padStart(2, "0")

  return `${day}.${month}.${year} ${hours}:${minutes}`
}

const user = JSON.parse(localStorage.getItem('user'))

export const BillModal = ({ openBill, setOpenBill, templates, formdata, calculatedSum, money, balance, postResponse, data }) => {
  const [cityName, setCityName] = useState('')
  const {data: citiesData} = useGetCitiesQuery()

  const addressStr = () => {
    const street = user?.salon?.street ? String(user.salon.street).trim() : ""
    const building = user?.salon?.building ? String(user.salon.building).trim() : ""
    const parts = []
    if (cityName) parts.push(`г. ${cityName}`)
    if (street) parts.push(`ул. ${street}`)
    if (building) parts.push(building)
    return parts.join(", ")
  }

  useEffect(() => {
    const cityName = citiesData?.find(item => item.id === user?.salon?.city_id)
    setCityName(cityName?.name)
  }, [citiesData])

  const openPdfInNewTab = (pdf) => {
    // Преобразование документа jsPDF в blob
    const pdfBlob = pdf.output('blob');

    // Создание URL для blob-объекта
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Открытие PDF в новой вкладке
    window.open(pdfUrl, '_blank');
  };

  const generatePdf = async () => {
    const content = document.getElementById("bill-content");
    if (!content) return

    const canvas = await html2canvas(content, {
      scale: 2, // увеличить качество
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");

    // Создаём PDF формата A5 (в мм), затем масштабируем изображение так, чтобы поместилось на страницу
    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a5" });

    const pdfWidth = pdf.internal.pageSize.getWidth(); // mm
    const pdfHeight = pdf.internal.pageSize.getHeight(); // mm

    // Конвертация пикселей в мм (предполагаем DPI = 96 для html2canvas)
    const pxToMm = (px) => (px * 25.4) / 96;
    const imgWidthMm = pxToMm(canvas.width);
    const imgHeightMm = pxToMm(canvas.height);

    // Масштабируем изображение, чтобы оно поместилось на странице A5
    const scale = Math.min(pdfWidth / imgWidthMm, pdfHeight / imgHeightMm, 1);
    const finalWidth = imgWidthMm * scale;
    const finalHeight = imgHeightMm * scale;

    const x = (pdfWidth - finalWidth) / 2;
    const y = (pdfHeight - finalHeight) / 2;

    pdf.addImage(imgData, "PNG", x, y, finalWidth, finalHeight);
    openPdfInNewTab(pdf);
  };

  return (
    <Modal open={openBill} onClose={() => setOpenBill(false)}>
      <div className="bg-white text-black mx-4 mt-10 max-m-[358px] px-2 sm:mx-auto sm:max-w-[550px] pb-8 rounded-[8px] relative overflow-y-auto max-h-[90vh]">
        {/* Кнопка закрытия справа сверху */}
        <button
          onClick={() => setOpenBill(false)}
          className="absolute top-4 right-4 h-fit"
          style={{ zIndex: 10 }}
        >
          <Close
            sx={{
              color: "gray.main",
              "&:hover": { color: "gray.dark" },
            }}
          />
        </button>

        <div id={"bill-content"} className="bg-white mt-6 pb-6 rounded-t-[8px]">
          <div className="w-full mb-4 text-[16px] pt-8">
            <div className='flex sm:flex-row flex-col items-center justify-center gap-4'>
              <p className="font-bold">"Дента"</p>
              <p className="font-bold">{addressStr()}</p>
            </div>
            <div className="flex sm:flex-row flex-col items-center justify-center gap-4">
              <p className="font-bold">{`тел: +992 ${user?.salon?.phone}`}</p>
              <p className="font-bold">{getCurrentDateTime()}</p>
            </div>

            <p className="text-center font-bold">Кассир: {user?.surname} {user?.name[0]}.</p>
          </div>

          <div className="text-center mb-4">
            <p className="text-[16px] font-bold underline">Квитанция №{postResponse?.id || data?.report?.id}</p>
          </div>

          <div className='w-full  border-y border-black px-6 py-2 text-black font-semibold'>
            <div className='flex  flex-col sm:flex-row   sm:items-center sm:justify-between gap-4 sm:gap-[100px] w-full'>
              <div className='flex flex-col items-start justify-start'>
                <span className='text-[12px]'>ID анализа</span>
                <span className='text-[14px] font-medium'>{postResponse?.id || data?.report?.id}</span>
              </div>
              <div className='flex flex-col items-start justify-start'>
                <span className='text-[12px]'>ФИО</span>
                <span className='text-[14px] pr-[100px]  font-medium'>{postResponse?.surname || formdata.surname} {postResponse?.name || formdata.name} { postResponse?.patronymic || formdata?.patronymic || ''}</span>
              </div>
            </div>
            <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 sm:gap-[90px] mt-3'>
              <div className='flex flex-col items-start justify-start'>
                <span className='text-[12px]'>Номер телефона</span>
                <span className='text-[14px] font-medium'>{ postResponse?.phone || formdata.phone}</span>
              </div>
              <div className='flex flex-col items-start justify-start pr-[30px]'>
                <span className='text-[12px]'>Дата рождения</span>
                <span className='text-[14px] font-medium'>{postResponse?.birthday || formdata.birthday}</span>
              </div>
              <div className='flex flex-col items-start justify-start'>
                <span className='text-[12px]'>Пол</span>
                <span className='text-[14px] font-medium'>{postResponse?.sex || formdata.sex}</span>
              </div>
            </div>
          </div>

          <div className='flex items-center justify-between pr-[100px] mt-[12px] px-6'>
            <p className='text-[12px] font-semibold'>Услуга</p>
            <p className='text-[12px] font-semibold'>Цена</p>
          </div>

          {(data?.templates || templates)?.map(item => <div key={item.id} className="flex items-center justify-between pr-[75px] mt-3 px-6">
            <p className=" text-[14px] font-medium">{item?.name} {item?.tests} {item?.tests === 1 ? 'показатель' : item?.tests > 1  && item?.tests < 5 ? 'показателя' : 'показателей'}</p>
            <p className=" text-[14px] font-medium">{item?.price}</p>
          </div>)}

          <div className='w-full flex items-center justify-between px-6 mt-6'>
            <span className='font-medium text-[16px]'>Итог:</span>
            <span className='font-medium text-[16px]'>{postResponse.total_sum ? `${postResponse.total_sum}.00 TJS` : calculatedSum}</span>
          </div>
          <div className='w-full flex items-center justify-between px-6 mt-2'>
            <span className='text-[16px]'>Оплачен</span>
            <span className='text-[16px]'>{money || '0'}.00 TJS</span>
          </div>
          <div className='w-full flex items-center justify-between px-6 mt-2'>
            <span className='text-[16px]'>Остаток</span>
            <span className='text-[16px]'>{postResponse.balance ? `${postResponse.balance}.00 TJS` : balance}</span>
          </div>
        </div>
        <div className='flex items-center justify-center mt-3'>
          <button type={'button'} onClick={generatePdf} className='btnFilled'>Распечатать</button>
        </div>

      </div>

    </Modal>


  )
}

